import { render, staticRenderFns } from "./LinkedFieldsTextarea.vue?vue&type=template&id=6429b0a4&"
import script from "./LinkedFieldsTextarea.vue?vue&type=script&lang=js&"
export * from "./LinkedFieldsTextarea.vue?vue&type=script&lang=js&"
import style0 from "./LinkedFieldsTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports